import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import IntlProps from "../../../state/helpers/IntlProps"
import "./WarningLabel.scss"

export enum WarningType {
    WARNING = "warning",
    DANGER = "danger",
}

type OwnProps = {
    paymentLabels: PaymentLabelData[],
    message: FormattedMessage,
    type: WarningType,
}

export interface PaymentLabelData {
    id: string,
    identifier: string,
}

const WarningLabel = (props: OwnProps & IntlProps) => {
    return (
        <div className={`warning-label ${props.type}`}>
            <div className="icon"><i className="fa fa-exclamation" /></div>
            <div className="label">
                {props.paymentLabels.map((payment, i) => (
                    <span key={payment.id} className="identifier">
                        <a
                            key={payment.id}
                            href={`/payments/${payment.id}/edit`}
                            target="_blank"
                            rel="noreferrer"
                        >{payment.identifier}</a>
                        {i < props.paymentLabels.length - 1 && <span>,</span>}
                    </span>
                ))}
                {props.message}
            </div>
        </div>
    )
}

export default injectIntl(WarningLabel)



// WEBPACK FOOTER //
// ./src/invoice/components/WarningLabel/WarningLabel.tsx